// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Calendly = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Calendly = void 0;
  _react = _interopRequireWildcard(_react);
  var React = _react;
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Calendly = _exports.Calendly = function Calendly(props) {
    return /*#__PURE__*/React.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/React.createElement("g", {
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: 0.054,
      clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M19.34 17.711a2.04 2.04 0 0 1-2.044 2.05H2.708a2.047 2.047 0 0 1-2.044-2.044V3.124c0-1.127.917-2.045 2.044-2.045h14.588c1.127 0 2.044.918 2.044 2.045zM2.708 2.172a.95.95 0 0 0-.951.952V17.71a.95.95 0 0 0 .951.952h14.588a.95.95 0 0 0 .951-.952V3.124a.95.95 0 0 0-.951-.952z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6.19 3.705a.413.413 0 1 1-.827.005V.655c0-.23.184-.413.413-.413.23 0 .414.183.414.413zm6.55 4.565a.15.15 0 0 1 .01.217l-.002.001a.15.15 0 0 1-.216.01v-.001a2.96 2.96 0 0 0-1.998-.774 2.976 2.976 0 0 0-2.974 2.974 2.976 2.976 0 0 0 2.974 2.974 2.96 2.96 0 0 0 1.997-.773.16.16 0 0 1 .217.008.16.16 0 0 1-.009.218 3.22 3.22 0 0 1-2.205.862 3.286 3.286 0 0 1-3.284-3.284 3.286 3.286 0 0 1 3.284-3.284c.82 0 1.601.302 2.205.852Zm1.447-4.146a.41.41 0 0 1-.413-.414V.655c0-.23.184-.413.413-.413.23 0 .414.183.414.413v3.05c0 .23-.184.419-.414.419Z"
    })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
      id: "prefix__a"
    }, /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      d: "M0 0h20v20H0z"
    }))));
  };
});
